import { Routes } from '@angular/router';

export const APP_ROUTES: Routes = [
  {
    path: 'public',
    loadChildren: () => import('@features/public/public.routes').then(m => m.PUBLIC_ROUTES),
  },
  {
    path: 'guests',
    loadChildren: () => import('@features/guests/guests.routes').then(m => m.GUESTS_ROUTES),
  },
  {
    path: 'users',
    loadChildren: () => import('@features/users/users.routes').then(m => m.USERS_ROUTES),
  },
  {
    path: 'residents',
    loadChildren: () => import('@features/residents/residents.routes').then(m => m.RESIDENTS_ROUTES),
  },
  {
    path: '**',
    redirectTo: '/guests',
  }
];
